/**
 * AddCategoryCtrl controller
 * Add/edit categories
 */

/**
 * AddCategoryCtrl controller
 *
 * @class AddCategoryCtrl
 * @memberof mwApp/sets
 * @see mwApp/sets
 *
 * @ngdoc controller
 * @name mwApp/sets.controller:AddCategoryCtrl
 */
/* @ngInject */
export default function AddCategoryCtrl ($uibModalInstance, cat, categoryNames, alertLiteSvc) {
  var vm = this
  vm.cat = cat
  vm.isNew = cat._isNew()

  vm.categoryNames = vm.isNew
    ? categoryNames
    : categoryNames.filter(n => n !== cat.name)

  vm.submit = function () {
    vm.setDisable()
    cat._clone()
      ._modify(
        cat => {
          cat.categorySet = null
          cat.parentCategory = null
          cat.subCategories = null
          cat.sortOrder = null
        }
      )
      ._save(null, null, null, null, cat.categorySet)
      .then(
        () => $uibModalInstance.close(cat)
      )
      .catch(rejection => alertLiteSvc.alertError(rejection))
      .finally(vm.unsetDisable)
  }

  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
